export function uppercaseFilter(value: string = '') {
  return value.toUpperCase()
}
